<template>
  <div class="api-users-page">
    <app-page-header title="Admins">
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus" />NOVO
      </button>
    </app-page-header>

    <api-users-table></api-users-table>
  </div>
</template>

<script>
import ApiUsersTable from '@/components/Tables/ApiUsersTable.vue';

export default {
  name: 'api-users-page',
  components: {
    ApiUsersTable,
  },
  methods: {
    create() {
      this.$router.push('/api-users/create');
    },
  },
};
</script>

<style lang="scss" scoped></style>
